import { ref as i, defineComponent as p, onMounted as b, watch as I, openBlock as V, createElementBlock as _, toDisplayString as g } from "vue";
const h = () => {
  const s = i(null), t = i(!1), n = (e, l) => ({
    root: e,
    threshold: l
  }), a = (e) => {
    e[0].isIntersecting && (t.value = e[0].isIntersecting);
  }, o = new IntersectionObserver(a, n(null, 0.5));
  return {
    observedElement: s,
    observer: o,
    isIntersecting: t
  };
}, E = /* @__PURE__ */ p({
  __name: "AnimatedCounter",
  props: {
    value: { default: 0 },
    duration: { default: 1e3 }
  },
  setup(s) {
    const t = s, { observedElement: n, observer: a, isIntersecting: o } = h(), e = i(0), l = () => {
      const r = t.value, d = r - 0;
      let u = 0;
      const f = r > 0 ? 1 : -1, m = Math.abs(Math.floor(t.duration / d)), v = setInterval(() => {
        u += f, e.value = u, u === r && clearInterval(v);
      }, m);
      return () => clearInterval(v);
    };
    return b(() => {
      n.value !== null && a.observe(n.value);
    }), I(() => o.value, (c) => {
      c && l();
    }), (c, r) => (V(), _("div", {
      ref_key: "observedElement",
      ref: n
    }, g(e.value), 513));
  }
});
export {
  E as default
};
